import { io, Socket } from 'socket.io-client';

const rawBaseUrl = process.env.REACT_APP_API_BASE_URL || '';
const serverUrl = rawBaseUrl.replace(/\/api\/?$/, '') || window.location.origin;

let socket: Socket | null = null;

export const getSocket = (): Socket => {
  if (!socket) {
    socket = io(serverUrl, {
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
      reconnectionDelay: 2000,
    });
  }
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
};
